export default function ChronicleSectionMasthead({
  title,
  description,
  controls = null,
  className = "",
}) {
  return (
    <section className={`edge-mobile px-5 pt-1 sm:px-1 ${className}`}>
      <div className="flex flex-col gap-4 border-b border-[var(--border)] pb-5 sm:flex-row sm:items-start sm:justify-between">
        <div className="min-w-0 flex-1">
          <h2
            className="text-[var(--fg-primary)]"
            style={{ fontSize: "20px", lineHeight: "28px", fontWeight: 600 }}
          >
            {title}
          </h2>
          {description ? (
            <p
              className="mt-1 max-w-2xl text-[var(--fg-secondary)]"
              style={{ fontSize: "13px", lineHeight: "18px" }}
            >
              {description}
            </p>
          ) : null}
        </div>
        {controls ? <div className="flex flex-wrap items-center gap-3 sm:ml-auto sm:shrink-0 sm:justify-end">{controls}</div> : null}
      </div>
    </section>
  );
}
